module.exports = __webpack_public_path__ + "static/img/newWeChatImg.968376a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/index/newWeChatImg.png
// module id = uCG1
// module chunks = 1